export default "__VITE_ASSET__Kkg2o8Xm__"